import Aos from "aos";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./about.scss";

function Home() {
	Aos.init({
		delay: 500,
		once: true
	});
	return (
		<div className="sec5">
			<div className="container">
				<div className="awards">
					<div className="col-md-7 col-md-4 row hidetab"></div>
					<div className="sec5Head col-lg-5 col-md-8" data-aos="zoom-in-up">
						<h6 className="small-title" data-aos="flip-down">
							GGI Aim
						</h6>
						<h6 className="title" data-aos="fade-up-left">
							Our Mission
						</h6>
						<p data-aos="flip-up">
					
						GGILab is committed to building trust in the gemstone industry. We achieve this by providing accurate and reliable identification and grading reports for gemstones. Additionally, we organize educational seminars and workshops to keep our clients informed about the latest trends and treatments in the industry. By continuously investing in state-of-the-art equipment and training our staff, we strive to maintain the highest standards of excellence.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
const mapStateToProps = ({ store }) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Home);
